import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@base/base.component';
import { EnumPath } from '@enums/path';
import { PERMITION_CONSORTIUM_READ_CRITERIA_CONSORTIUM, PERMITION_CONSORTIUM_REPORTS_COMISSIONS_READ, PERMITION_CONSORTIUM_REPORTS_PORTFOLIO_MANAGEMENT_READ, PERMITION_CONSORTIUM_SALES_PANEL_READ } from 'src/app/const/permitions';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent extends BaseComponent {

  get hasPermissionReadCriteriaConsortium(): boolean {
      return this.getPermissions()
                 .some(p => [PERMITION_CONSORTIUM_READ_CRITERIA_CONSORTIUM].includes(p));
    }

    get hasPermissionComissionReports(): boolean {
      return this.getPermissions()
                 .some(p => [PERMITION_CONSORTIUM_REPORTS_COMISSIONS_READ].includes(p));
    }

    get hasPermissionPortfolioManagement(): boolean {
      return this.getPermissions()
                 .some(p => [PERMITION_CONSORTIUM_REPORTS_PORTFOLIO_MANAGEMENT_READ].includes(p));
    }

    get hasPermissionSales(): boolean {
      return this.getPermissions()
                 .some(p => [PERMITION_CONSORTIUM_SALES_PANEL_READ].includes(p));
    }

    navigateToConsortiumRelationshipPanel(event: MouseEvent) {
        // this.router.navigate([EnumPath.CONSORTIUM_RELATIONSHIP_PANEL]);
    }

    navigateToConsortiumSalesPanel() {
      this.router.navigate([EnumPath.CONSORTIUM_SALES_PANEL])
    }

    navigateToConsortiumReportsCommissions() {
      this.router.navigate([EnumPath.CONSORTIUM_REPORTS_COMMISSIONS])
    }

    navigateToConsortiumPortifolioManagement() {
      this.router.navigate([EnumPath.CONSORTIUM_REPORTS_PORTFOLIO_MANAGEMENT])
    }

}
